import { render, staticRenderFns } from "./KerryThBarcode.pug?vue&type=template&id=8fc7483c&scoped=true&lang=pug&"
import script from "./KerryThBarcode.vue?vue&type=script&lang=js&"
export * from "./KerryThBarcode.vue?vue&type=script&lang=js&"
import style0 from "./KerryThBarcode.scss?vue&type=style&index=0&id=8fc7483c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc7483c",
  null
  
)

export default component.exports